module.exports = "/static-assets/_next/static/images/img-cb89d3bd55-b5fc4ba17d9bbc0fd081ce8e41441710.webp";